import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15c87898"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-width", "data-design"]

interface Props {
  /** width of section */
  width?: "full" | "medium" | "big";
  /** visual design */
  design?: "normal" | "fill";
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSection',
  props: {
    width: { default: "medium" },
    design: { default: "normal" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "section",
    "data-width": __props.width,
    "data-design": __props.design
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})